// extracted by mini-css-extract-plugin
module.exports = {"joinTenancyNames":"styles_joinTenancyNames__6bB68","tooltip":"styles_tooltip__LEwbO","tooltiptext":"styles_tooltiptext__3DRLj"};